<template>
	<div>
		<div class="card mb-4">
	        <div class="card-header">
				<div class="d-flex justify-content-between container-fluid">
		            <div class="text-muted fs-19">
		            	<strong>Materiais</strong>
		            </div>
		            <button
		            	@click="create()"
		            	class="btn btn-primary noprint">
		            	Novo
		            </button>
			    </div>
		    </div>
		    <div class="card-body">
		        <material-table
		        	@update="update"
					@destroy="destroy">
		        </material-table>
		    </div>
		</div>
		<material-create
			@reload="reload">
		</material-create>
		<material-update
			:dado_id="dado_id"
			@reload="reload">
		</material-update>
		<bsh-confirm 
        	modal_id="confirm_destroy_produto_material" 
        	:dado_id="dado_id" 
        	title="Deseja realmente excluir este material?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/produto-materiais/destroy/'" 
        	@reload="reload">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dado_id: 0
			}
		},
		methods: {
			create(){
				$('#create_produto_material').modal('show');
			},
			update(id){
				this.dado_id = id;
				$('#update_produto_material').modal('show');
			},
			destroy(id){
				this.dado_id = id;
				$('#confirm_destroy_produto_material').modal('show');
			},
			reload(){
				this.$emit('reload')
			}
		}
	}
</script>
